import React from 'react';
import MastGrid from '../../../../src/blog-post-components/mast-nazron-se/mast-content-grid.js';
export default {
  React,
  MastGrid
};